import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dashboards-twin-table-table-component"
  }, [_c(VDataTable, {
    attrs: {
      "loading": _vm.loading,
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": _vm.completeWidget.twinTableOptions.rowsPerPage || 10,
      "footer-props": {
        itemsPerPageOptions: _vm.itemsPerPageOptions
      },
      "options": _vm.tableOptions,
      "fixed-header": _vm.headers.some(header => header.width)
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item,
        headers
      }) {
        return [_c('tr', {
          style: {
            cursor: _vm.rowHasClickHandler(item).isTrue ? 'pointer' : undefined
          },
          on: {
            "click": function ($event) {
              return _vm.onRowClick(item);
            }
          }
        }, _vm._l(headers, function (header) {
          return _c('td', {
            key: header.text,
            style: {
              width: header.width,
              maxWidth: header.width,
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }
          }, [header.component !== 'string' ? _c(header.component, {
            tag: "component",
            attrs: {
              "data": _vm.getByKey(item, header.value)
            }
          }) : _c('span', {
            attrs: {
              "title": _vm.getByKey(item, header.value)
            }
          }, [_vm._v("\n            " + _vm._s(_vm.getByKey(item, header.value)) + "\n          ")])], 1);
        }), 0)];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };